var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 61,
    viewBox: "0 0 54 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0954 2.35986L22.3934 0.141602L21.6882 4.39889C20.5659 11.1212 15.9736 17.3676 10.9084 21.7571C0.992318 30.354 -1.17893 39.6971 1.89137 47.4096C4.82946 54.7901 12.2863 59.8436 19.8549 60.6868L21.606 60.8807C17.2752 58.2335 14.4958 52.0488 15.4654 47.4272C16.4232 42.8849 19.6903 38.6306 25.9661 34.7053L29.1304 32.7309L30.3115 36.2713C31.0078 38.3632 32.2125 40.0438 33.4376 41.7508C34.0253 42.5735 34.6217 43.405 35.1682 44.2893C37.0574 47.3597 37.5569 50.7737 36.3375 54.1613C35.2269 57.2405 33.3965 59.6614 30.8727 61.0041L33.7226 60.6868C40.8269 59.8965 46.0421 57.4667 49.4297 53.4033C52.7879 49.3752 53.9661 44.1895 53.9661 38.6688C53.9661 33.5271 51.8536 28.2268 49.3621 23.8167C46.4416 18.6516 42.6309 14.362 38.4706 10.2046C37.7508 11.6442 37.8066 12.226 36.3258 14.5382C34.4037 9.43124 30.7941 5.13438 26.0954 2.35986Z",
    fill: "#106F60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/fireIcon.c89bd85b138f276c4f99dad5ea0c725f.svg";
export { ForwardRef as ReactComponent };